module.exports = __webpack_public_path__ + "img/eSealBanner.4732fa87.png";